import { FC } from "react";
import FiltersBarContent, { FiltersBarContentProps } from "../components/FiltersBarContent";

const FiltersBarWeb: FC<FiltersBarContentProps> = (props) => {
  return (
    <div className="flex flex-col p-4">
      <FiltersBarContent {...props} />
    </div>
  );
};

export default FiltersBarWeb;
